/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.popup-title-label[_ngcontent-%COMP%]{font-size:18px}.contract-editor-content[_ngcontent-%COMP%]   .auto-renew-frequecies[_ngcontent-%COMP%]{display:flex;align-items:center}.contract-editor-content[_ngcontent-%COMP%]   .contract-editor-form[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:5px}.contract-editor-content[_ngcontent-%COMP%]   .attachment-container[_ngcontent-%COMP%]{display:flex;flex-direction:row!important}"];
export { styles as styles };
